import React, { useState, useEffect } from "react";
import {
  SeriesListContainer,
  SeriesPopUpContainer,
  SeriesCreatorContainer,
  SeriesItem,
  SeriesListMainContainer,
  TitleInputField,
  DescriptionInputField,
  SeriesCreatorListContainer,
} from "./StorySeriesManager.styled";
import {
  ThemeButton,
  SubHeading,
  AlignContentHorizontal,
  FlatBackdrop,
  LoadingContainer,
  InfiniteScrollParentContainer,
  InfiniteScrollLoader,
} from "static/styled/custom.styled";
import { module as ui } from "@st/ui";
import { module as story } from "@st/story";
import { connectStore } from "redux-box";
import swal from "sweetalert2";
import { NavigationHeaderContainer } from "static/styled/NavigationBar.styled";
import InfiniteScroll from "react-infinite-scroller";
import SeriesStoryReorder from "./SeriesStoryReorder";
import Select from 'react-select'

const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    position: "absolute",
  }),
  control: (provide) => ({
    ...provide,
    width: "100%",
    margin: "0 auto",
    border: "1px solid grey",
    boxShadow: "none",
    borderRadius: '10px'
  }),
};

const SeriesTypes = [
  {
    label: 'Freadom Story',
    value : 'Freadom Story'
  },
  {
    label: 'AI Magic Story',
    value : 'AI Magic Story'
  }
]

const StorySeriesManager = ({ story }) => {
  const [seriesInfo, setSeriesInfo] = useState({
    name: "",
    type: "",
    description: "",
    stories: [],
    id : null
  });
  const [activeSeries, setActiveSeries] = useState(null)
  const [storiesModified, setStoriesModified] = useState(false)

  useEffect(() => {
    if (activeSeries) {
      normalizeForState(activeSeries)
    } else {
      setSeriesInfo({
        name: "",
        type: "",
        description: "",
        stories: []
      })
    }
  }, [activeSeries])

  const normalizeForState = (active_series) => {
    let type = SeriesTypes.find(type => type.value === active_series.type)
    setSeriesInfo({
      name: active_series.name,
      type: type,
      stories: active_series.stories,
      description: active_series.description,
      id : active_series.id
    });
  }

  const handleSeriesNameChange = (evt) => {
    setSeriesInfo({
      ...seriesInfo,
      name: evt.target.value,
    });
  };

  const handleSeriesDescriptionChange = (evt) => {
    setSeriesInfo({
      ...seriesInfo,
      description: evt.target.value,
    });
  };

  useEffect(() => {
    story.requestGetAllSeries()
  }, [])


  const updateSeries = () => {

    if (seriesInfo.name !== "" && seriesInfo.type.value !== "") {
      let payload = {
        name : seriesInfo.name,
        type: seriesInfo.type.value,
        description : seriesInfo.description,
        id : seriesInfo.id ? seriesInfo.id : activeSeries.id
      }
      if(storiesModified){
        payload['stories_order'] = seriesInfo.stories.map((story) => story.id)
      }
      story.requestUpdateSeries(payload);
      setStoriesModified(false)
    }
    else {
      swal("Oops!", "You forget to enter the series name or type", "warning");
    }
  };

  const createSeries = () => {
    if (seriesInfo.name !== "" && seriesInfo.type.value !== "") {
      let payload = {
        name : seriesInfo.name,
        type: seriesInfo.type.value,
        description : seriesInfo.description
      }
      story.requestCreateSeries(payload);
      setSeriesInfo({
        name: "",
        type: "",
        stories: [],
        description : '',
        id : null
      });
    } else {
      swal("Oops!", "You forget to enter the series name or type", "warning");
    }
  };

  const fetchMoreSeries = () => {
    if (
      story.series_result !== null &&
      story.series_result.has_next
    ) {
      setTimeout(() => {
        if (
          story.Seriess_result !== null &&
          story.Seriess_result.next_page > 0
        )
          story.requestSeriessListConcat(
            story.Seriess_result.next_page
          );
      }, 100);
    }
  }

  const handleStoryOrderChange = function (newStoriesOrder) {
    setSeriesInfo({
      ...seriesInfo,
      stories: newStoriesOrder
    });
    setStoriesModified(true)
  };

  const handleSeriesClick = (series) => {
    setActiveSeries(series)
    story.requestGetSeriesData(series.id)
  }

  const handleSeriesTypeChange = (selectedType)=>{
    setSeriesInfo({
      ...seriesInfo,
      type: selectedType,
    });
  }

  return (
    <SeriesPopUpContainer style={{ overflowY: "hidden" }}>
      <SeriesListMainContainer>
        <NavigationHeaderContainer zIndex={10} shadow>
          Series
        </NavigationHeaderContainer>
        <SeriesListContainer>
          {story.fetch_series ? (
            <LoadingContainer>
              <div>
                <img
                  alt="loading"
                  width="60"
                  height="60"
                  src={require("static/img/Theme-loader.gif")}
                />
              </div>
            </LoadingContainer>
          ) : (
            <InfiniteScrollParentContainer height={'330px'} noTop>
              <InfiniteScroll
                pageStart={0}
                loadMore={fetchMoreSeries}
                style={{ position: "relative" }}
                hasMore={story.series_result && story.series_result.has_next}
                loader={
                  <InfiniteScrollLoader className="loader" key={0}>
                    <img
                      alt="loader"
                      width="50"
                      height="50"
                      src={require("static/img/Theme-loader.gif")}
                    />
                  </InfiniteScrollLoader>
                }
                useWindow={false}
              >
                {story.series_list && story.series_list.length > 0 && (
                  <AlignContentHorizontal>
                    {story.series_list.map((series, index) => (
                      <div className="col-sm-8 col-md-5 col-lg-6" key={index}>
                        <SeriesItem
                          key={index}
                          onClick={() => handleSeriesClick(series)}
                        >
                          <FlatBackdrop
                            style={{ backgroundColor: "rgba(67,38,102,0.5)" }}
                          />
                          <SubHeading
                            style={{ fontWeight: "normal", color: "white", zIndex: "10", wordBreak: 'break-word', minWidth: 0, marginBottom: 0 }}
                          >
                            {series.name}
                          </SubHeading>
                        </SeriesItem>
                      </div>
                    ))}
                  </AlignContentHorizontal>
                )}
              </InfiniteScroll>
            </InfiniteScrollParentContainer>
          )}
        </SeriesListContainer>
      </SeriesListMainContainer>

      <SeriesCreatorContainer>
        <NavigationHeaderContainer shadow>
          {activeSeries
            ? "Edit Series"
            : "Add Series"}
        </NavigationHeaderContainer>
        <SeriesCreatorListContainer>
          {story.fetching_series_details ? (
            <LoadingContainer>
              <div>
                <img
                  alt="loading"
                  width="60"
                  height="60"
                  src={require("static/img/Theme-loader.gif")}
                />
              </div>
            </LoadingContainer>
          ) : (
            <div style={{ padding: "10px 15px", flex: 1, width: '100%' }}>
              <TitleInputField
                type="text"
                placeholder="Give it a title"
                onChange={handleSeriesNameChange}
                value={seriesInfo.name}
              />
              <DescriptionInputField
                placeholder="Description"
                onChange={handleSeriesDescriptionChange}
                value={seriesInfo.description}
              />

              <Select
                className="dropdown-container"
                value={seriesInfo.type}
                onChange={handleSeriesTypeChange}
                options={SeriesTypes && SeriesTypes.length >= 1 && SeriesTypes}
                placeholder="Select Type"
                styles={customStyles}
                menuPlacement="auto" // auto, top, or bottom
                menuPosition="fixed"
              />

              {
                activeSeries && (
                  <React.Fragment>
                    <h5>Stories</h5>
                    <SeriesStoryReorder
                      seriesStories={seriesInfo.stories}
                      onOrderChange={handleStoryOrderChange}
                    />
                  </React.Fragment>
                )
              }
            </div>
          )}
          {story.fetching_series_details ? null : activeSeries ? (
            <ThemeButton primary onClick={updateSeries}>
              {" "}
              Save Series
            </ThemeButton>
          ) : (
            <ThemeButton primary onClick={createSeries}>
              Add Series
            </ThemeButton>
          )}
        </SeriesCreatorListContainer>
      </SeriesCreatorContainer>
    </SeriesPopUpContainer>
  )
}

export default connectStore({
  ui,
  story,
})(StorySeriesManager)